import './prism';

import { Injectable } from '@rxdi/core';

import { marked, Renderer } from './marked';

interface Prism {
  highlightElement(code: HTMLElement): void;
}

declare let Prism: Prism;

@Injectable()
export class MarkdownParserService {
  private renderer = new Renderer();

  highlightElements(tags: NodeListOf<HTMLElement>[]) {
    return [].forEach.call(tags, (code: HTMLElement) => {
      if (code.className) {
        Prism.highlightElement(code);
      }
    });
  }

  readAndCompile(text: string) {
    const html = `<div part="content" class="content" #contentReference>
      ${marked(text, { renderer: this.renderer })}
    </div>`;

    return html + '\n';
  }

  async fetchMarkdown(link: string) {
    const res = await fetch(link);
    if (res.status !== 200) {
      throw new Error(`Unable to load markdown status is ${res.status}`);
    }
    const text = await res.text();
    return this.readAndCompile(text);
  }
}
